export default __webpack_public_path__ + "static/media/back.ebc8902f.svg";